import * as types from './types';
import fetchData from '../../../shared/helpers/fetchData';
import fetchOptions from '../../../shared/helpers/fetchOptions';


const updateReviews = (product) => {
  const reviewsContainer = window.document.querySelector('[data-bv-show="reviews"]');

  if (reviewsContainer) {
    const { reviewProductId } = product;

    reviewsContainer.setAttribute('data-bv-product-id', reviewProductId);
  }
};

export const receiveProductVariationResult = ({ product }) => {
  updateReviews(product);

  return {
    type: types.RECEIVE_PRODUCT_VARIATION_RESULT,
    product,
  };
};

const startLoading = () => ({
  type: types.IN_FLIGHT,
});

export const fetchProductVariation = function fetchProductVariationAction(url) {
  return function requestProductVariation(dispatch) {
    const options = fetchOptions('get');
    const handlers = {
      successHandler: receiveProductVariationResult,
      dispatch,
    };

    dispatch(startLoading());
    return fetchData(url, options, handlers);
  };
};
